import { render } from "./ProductLimitExceededDialog.vue?vue&type=template&id=c1dbaa26&scoped=true"
import script from "./ProductLimitExceededDialog.vue?vue&type=script&lang=js"
export * from "./ProductLimitExceededDialog.vue?vue&type=script&lang=js"

import "./ProductLimitExceededDialog.vue?vue&type=style&index=0&id=c1dbaa26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1dbaa26"]])

export default __exports__